import { styled } from '@mui/system';
import React, { PureComponent } from 'react';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu/Menu';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import { Text, Theme, Services, Modal } from '@simplybenefits/sb-ui-library';
import { constants } from '@simplybenefits/sb-utils';
import PermissionsComponent from './PermissionsComponent.js';

const StyledData = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: 0.8,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('460')]: {
        flex: 0.8
    }
}));

const StyledNameBlock = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: 0.3,
    alignItems: 'center',
    backgroundColor: Theme.colors.lightBlue,
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
        flex: 0.5
    },
    [theme.breakpoints.down('570')]: {
        flex: 0.6
    },
    [theme.breakpoints.down('460')]: {
        flex: 1
    }
}));

class PersonBlock extends PureComponent {
    state = {
        anchorEl: null,
        showForgotPasswordModal: false
    };

    _handleMenuClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    _handleCloseMenu = () => {
        this.setState({ anchorEl: null });
    };

    _toggleForgotPasswordModal = () => {
        this.setState({ showForgotPasswordModal: !this.state.showForgotPasswordModal });
    };

    _sendForgotPassword = async () => {
        await this.props.sendForgotPassword();
        this.setState({ showForgotPasswordModal: false });
    };

    render() {
        const { edit, remove, reinstate, firstname, relationship, percentage, termDate, manageBenefits, sendForgotPassword, testid, id } = this.props;
        const styles = {
            blockRow: {
                alignItems: 'center',
                backgroundColor: Theme.colors.surface,
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                height: 60,
                marginBottom: 5
            }
        };

        let status = isNaN(this.props.status) ?
            this.props.status || ''
            :
            constants.memberStatusMap[this.props.status];

        return (
            <div id={id || testid} style={styles.blockRow}>
                <StyledNameBlock onClick={this.props.type !== 'dependent' ? edit : null}>
                    <Text medium>{ firstname }</Text>
                    <Text
                        color={Theme.colors.darkBlue}
                        small
                    >
                        { relationship }
                    </Text>
                </StyledNameBlock>

                <StyledData>
                    {
                        percentage &&
                            <Text medium>{`${ percentage }%`}</Text>
                    }

                    {
                        this.props.type === 'dependent' && status && status === 'Terminated' ?
                            <Text medium bold color={ Theme.colors.red }>&nbsp;Terminated&nbsp;{Services.dates.formatIncomingDate(termDate)}</Text>
                            :
                            <Text
                                small
                                margin="0 10px"
                                color={ status === 'Active' ? Theme.colors.brandGreen : status === 'Terminated' ? Theme.colors.red : Theme.colors.darkGrey }
                                uppercase
                                bold
                            >
                                { status }
                            </Text>
                    }

                    {
                        relationship !== 'Survivor Benefit' ?
                            <IconButton
                                aria-label="Edit"
                                onClick={this._handleMenuClick}
                                style={{ padding: "12px", color: Theme.colors.mainTextGrey }}
                            >
                                <MoreVertIcon />
                            </IconButton>
                            :
                            <div style={{ width: 50 }} />
                    }
                </StyledData>

                <Menu
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl)}
                    onClose={this._handleCloseMenu}
                    onClick={this._handleCloseMenu}
                    disableAutoFocusItem={true}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                    }}
                >
                    <MenuItem onClick={edit} sx={{ width: "250px" }}>
                        <Text
                            medium
                            display="inline"
                        >
                            Edit
                        </Text>
                    </MenuItem>

                    <MenuItem onClick={remove} sx={{ width: "250px" }}>
                        <Text
                            medium
                            display="inline"
                        >
                            Remove
                        </Text>
                    </MenuItem>

                    {
                        status.toUpperCase() === 'TERMINATED' &&
                            <MenuItem onClick={reinstate} sx={{ width: "250px" }}>
                                <Text
                                    medium
                                    display="inline"
                                >
                                    Reinstate
                                </Text>
                            </MenuItem>
                    }

                    <PermissionsComponent
                        permission="Dependents"
                        accessType={this.props.accessType}
                        level="write"
                    >
                        {
                            manageBenefits &&
                                <MenuItem onClick={manageBenefits} sx={{ width: "250px" }}>
                                    <Text
                                        medium
                                        display="inline"
                                    >
                                        Manage Benefits
                                    </Text>
                                </MenuItem>
                        }
                    </PermissionsComponent>

                    <PermissionsComponent
                        permission="Dependents"
                        accessType={ this.props.accessType }
                        level="write"
                    >
                        {
                            sendForgotPassword &&
                                <MenuItem onClick={ this._toggleForgotPasswordModal } sx={{ width: "250px" }}>
                                    <Text
                                        medium
                                        display="inline"
                                    >
                                        Send Forgot Password Email
                                    </Text>
                                </MenuItem>
                        }

                    </PermissionsComponent>
                </Menu>

                {
                    this.state.showForgotPasswordModal &&
                        <Modal
                            open={ this.state.showForgotPasswordModal }
                            onClose={ () => this._toggleForgotPasswordModal() }
                            title="Reset Password"
                            primaryButton={{
                                label: "Continue",
                                onClick: () => this._sendForgotPassword()
                            }}
                            loader={ this.props.loader }
                        >
                            <Text medium light>
                                You are about to send an email with a forgotten password link, are you sure you want to continue? This cannot be undone.
                            </Text>
                        </Modal>
                }

            </div>
        );
    }
}

export default (PersonBlock);